import {
  SET_CURRENT_PARTICIPATION,
  UPDATE_CURRENT_PARTICIPATION,
  USER_LOGOUT,
} from '../actions/types'

const initialState = {
  currentParticipation: {}
}

export default function locker(state = initialState, action){
  const { participation } = action

  switch (action.type) {
    case SET_CURRENT_PARTICIPATION:
      let newState = {
        ...state,
        currentParticipation: participation
      }
      return newState
    case UPDATE_CURRENT_PARTICIPATION:
      return state
    case USER_LOGOUT:
      return initialState
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/locker.js